module.exports = __webpack_public_path__ + "static/media/FacialApp.53866c3b.webp";